import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { IListType } from "../store";
import { notification } from "antd";
import deviceManagementDataAccess from "src/dataAccess/deviceManagement/deviceManagementDataAccess";

export const getDeviceListSuccess = createAction<any>(
  "[Device] Get Device List Success"
);
export const LoadingData = createAction<boolean>("[Device] Loading data");
export const loadingList = createAction<boolean>("[Device] Loading list");

export const getDeviceListAsync = createAsyncThunk<any, IListType>(
  "[Device] Get device List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingList(true));

    const result = await deviceManagementDataAccess
      .deviceList(parameter)
      .then((res) => {
        thunkAPI.dispatch(getDeviceListSuccess(res));
        thunkAPI.dispatch(loadingList(false));
        return res;
      });
    return result;
  }
);

export const saveDeviceListSuccess = createAction<any>(
  "[Device] Save Device Success"
);



export const deleteDeviceAsync = createAsyncThunk<any, number | number[]>(
  "[Device] Delete Device(s)",
  async (deviceIdOrIds, thunkAPI) => {
    const idsToDelete: number[] = Array.isArray(deviceIdOrIds)
      ? deviceIdOrIds
      : [deviceIdOrIds];

    await deviceManagementDataAccess.deleteDeviceInfo(idsToDelete);

    const count = idsToDelete.length;
    const message = `${count} device${count === 1 ? "" : "s"} deleted successfully`;

    notification.success({ message });
    thunkAPI.dispatch(deleteDeviceSuccess(idsToDelete));
    return idsToDelete;
  }
);


export const deleteDeviceSuccess = createAction<number[]>(
  "[Device] Delete Device Success"
);
